import React, { useState } from 'react';
import OrderController from '@/services/OrderController';
import { toast } from 'react-hot-toast';
import BottomButtons from '@/ui/modal/bottom-buttons/BottomButtons';
import Modal from '@/ui/modal/Modal';
import Chip from '@/ui/chip/Chip';
import useStore from '@/store/store';
import { AreaPricePrompt } from '../area-price-prompt/AreaPricePrompt';
import s from './change-area-modal.module.css';

const ChangeAreaModal = ({ order, onClose, withFees, withShopFees }) => {
	const [area, setArea] = useState(null);
	// Cities with withAreaPriceConfirm: the new area's prices, asked before saving.
	const [prompt, setPrompt] = useState(null);

	const { user } = useStore();
	// A fixed charge (order.sfx) does not depend on the area.
	const areaShopFees = !!withShopFees && !order?.sfx;
	const confirmPrices =
		!!user?.cityLocation?.withAreaPriceConfirm && (!!withFees || areaShopFees);

	const onSave = async () => {
		if (!area) {
			toast.error('Πρέπει να διαλέξεις περιοχή');
			return;
		}
		if (!confirmPrices) {
			save();
			return;
		}
		// The shop's prices for the chosen area (same lists as on Live).
		const lists = await OrderController.getShopFeeList(order?.sh?.id);
		const idx = (user?.cityLocation?.areas || []).indexOf(area);
		setPrompt({
			listFee: lists?.feeList?.[idx] ?? null,
			listShopFee: lists?.shopFeeList?.[idx] ?? null,
		});
	};

	const save = async (prices = {}) => {
		try {
			// Awaited: without it the error branch below could never run.
			const res = await OrderController.updateCompletedOrderArea(order.id, area, prices);

			if (!res?.error) {
				toast.success('Η αλλαγή περιοχής έγινε');
				setArea(null);
				onClose();
				// onCloseCompleteModal();
			} else {
				console.log('on change area err 1', res?.code);
				toast.error(
					`Κάποιο πρόβλημα προέκυψε${typeof res.error === 'string' || res?.code ? ':' : ''}${
						typeof res.error === 'string' ? ` ${res.error}` : ''
					}${res?.code ? ` (${res.code})` : ''}`,
				);
				// toast.error(`Κάποιο πρόβλημα προέκυψε${typeof res.error === 'string' || res?.code ? ':' : ''}${typeof res.error === 'string' ? ` ${res.error}` : ''}${res?.code ? ` (${res.code})` : ''}`)
			}
		} catch (e) {
			console.log('on change area err 2: ', e);
		}
	};

	const areas = user?.cityLocation?.areas;

	if (prompt) {
		return (
			<AreaPricePrompt
				area={area}
				withFees={withFees}
				withShopFees={areaShopFees}
				oldFee={order?.fee ?? 0}
				oldShopFee={order?.shopFee ?? 0}
				listFee={prompt.listFee}
				listShopFee={prompt.listShopFee}
				onConfirm={prices => save(prices)}
				onAreaOnly={() => save()}
				onCancel={() => setPrompt(null)}
			/>
		);
	}

	return (
		<div className={'flex min-h-50 min-w-84 flex-col'}>
			<div className={`flex flex-col`}>
				<div className={`${s.areasContainer} ${s.areaContainerMaxWidth}`}>
					{areas?.map((it, idx) => (
						<Chip
							key={it}
							label={it}
							onClick={() => {
								setArea(it);
							}}
							selected={it === area}
						/>
					))}
				</div>
				<BottomButtons onSave={onSave} saveDisabled={false} text='Αλλαγή' />
			</div>
		</div>
	);
};

export default ChangeAreaModal;
